import NewsDetail from './NewsDetail';

const View = (props: any) => {
  return <NewsDetail content={props.content} />;
};

export default View;
